import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";

const PlayerCardModal = (props) => {
  const brandingDetails = JSON.parse(localStorage.getItem("branding"));
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const captureImage = () => {
    const modalContent = document.getElementById("playermoreinfo");
    if (modalContent) {
      html2canvas(modalContent, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.playerCardData?.full_name}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  };
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        id="playermoreinfo"
        size="lg"
      >
        <div className="player_star_info">
          <div className="player_star_pic">
            <Link
              className="player_profile_url"
              to={`/player-profile/${props.playerCardData.id}`}
            >
              <figure>
                {props.playerCardData?.is_avatar === 1 ? (
                  <img
                    src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${props.playerCardData.image}`}
                    alt="img"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}player/${props.playerCardData?.image}`}
                    alt="img"
                  />
                )}
              </figure>
            </Link>
            <div className="player_description">
              <h3>{props.playerCardData?.full_name}</h3>
              <div className="player_game_name">
                {props.playerCardData?.position_name},&nbsp;
                {clubDetails?.game_name}
              </div>
              <div className="player_game_name">
                Views: {props?.playerProfileView}
              </div>
            </div>
          </div>
          <div className="club_logo">
            <figure>
              {props.playerSponsor && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}sponsor/${props.playerSponsor.logo}`}
                  alt="img"
                />
              )}
              {!props.playerSponsor && brandingDetails && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails.logo}`}
                  alt="img"
                />
              )}
              {!brandingDetails && (
                <img src={`../images/small-brand-logo.jpg`} alt="img" />
              )}
            </figure>
          </div>
        </div>
        <ul className="game_progress_info">
          <li>
            <div className="progress_info">
              Fantasy Pts<strong>{props.playerCardModalData?.sum_fp}</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Fantasy Value
              <strong>
                {props.club_details?.default_salary_symbol}
                {props.playerCardData.svalue}m
              </strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Value Change
              <strong>
                {" "}
                {props.playerCardModalData?.valueChangeAvg
                  ?.value_change_in_percent >= 0
                  ? `+${props.playerCardModalData?.valueChangeAvg?.value_change_in_percent}`
                  : props.playerCardModalData?.valueChangeAvg
                      ?.value_change_in_percent}
                %
              </strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Picked in Teams
              {props.userPaidForClub === 1 ? (
                <strong>
                  {" "}
                  {props.modalTeamSelected} ({Math.round(props.playerSelected)}
                  %)
                </strong>
              ) : (
                <>
                  <br></br>
                  <Link
                    className="lock-img"
                    onClick={(event) => {
                      event.preventDefault();
                      props.handleGamePassModalShow();
                    }}
                  >
                    <img src="../images/lock-icon.png" alt="img" />
                  </Link>
                </>
              )}
            </div>
          </li>
          <li>
            <div className="progress_info">
              Avg Points
              <strong> {props.playerCardModalData?.avgPoints ?? "-"}</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Best Score
              <strong> {props.playerCardModalData?.bestScore ?? "-"}</strong>
            </div>
          </li>
        </ul>

        <div className="player-performance">
          <ul>
            <li>
              <div className="performancebox">
                Matches<strong>{props.playerCardModalData?.tot_match}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Goals<strong>{props.playerCardModalData?.sum_go}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Assists<strong>{props.playerCardModalData?.sum_ast}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Penalty Saves
                <strong>{props.playerCardModalData?.sum_ps}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Penalty Miss
                <strong>{props.playerCardModalData?.sum_pm}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                GK Saves<strong>{props.playerCardModalData?.sum_gks}</strong>
              </div>
            </li>

            <li>
              <div className="performancebox">
                Green Cards<strong>{props.playerCardModalData?.sum_gcd}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Yellow Cards
                <strong>{props.playerCardModalData?.sum_ycd}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Red Cards<strong>{props.playerCardModalData?.sum_rcd}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Clean Sheets
                <strong>{props.playerCardModalData?.sum_cst}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Played 60mins
                <strong>{props.playerCardModalData?.sum_p60}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Played 60+mins
                <strong>{props.playerCardModalData?.sum_p60plus}</strong>
              </div>
            </li>
            <li width="100%">
              <div className="performancebox">
                Own Goals<strong>{props.playerCardModalData?.sum_og}</strong>
              </div>
            </li>
          </ul>
          {props.playerSponsor?.name && (
            <div
              className="countdata"
              style={{
                backgroundColor: "#FFD43C",
                width: "100%",
                margin: "0px",
                padding: "7px 0px 1px",
              }}
            >
              <div className="gameweek-filter">
                <h4
                  style={{
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Sponsor: {props.playerSponsor?.name}
                </h4>
              </div>
            </div>
          )}
        </div>

        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link
              to={`/player-profile/${props.playerCardData.id}`}
              className="border-btn"
            >
              <i className="fas fa-user"></i>
            </Link>
            <Link
              to={`/player-charts?player_id=${props.playerCardData.id}`}
              className="border-btn"
            >
              <i className="fas fa-chart-line"></i>
            </Link>
            <Link
              onClick={captureImage}
              className="border-btn"
              style={{ textDecorationNo: "none", color: "black" }}
            >
              <i className="fas fa-download"></i>
            </Link>
            <Link className="border-btn" onClick={props.handleClose}>
              <i className="fas fa-times"></i>
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PlayerCardModal;
